<template>
  <div id="reportes-page" class="container-fluid">
    <!-- <div id="formulario-top" class="container">
      <div class="row">
        <div class="col-sm-2 col-sm-offset-2 col-xs-8 col-xs-offset-2">

        </div>
      </div>
    </div> -->
    <div class="row">
      <div class="col-md-6 col-xs-12" style="border-right:2px solid #999;">
        <div class="panel-body">
          <table class="table">
            <thead>
              <tr class="text-center nombre-alarma">
                <th colspan="3">Conteo General de Eventos</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" height="30px" >
                <td colspan="3">
                  <div style="margin-left: 20px; margin-right: 30px; display: inline;">
                    <date-picker :date="date" :option="option" @change="fecha = $event"></date-picker>
                  </div>
                  <button style="padding-left; 20px;" class="btn btn-default" @click="actualizar()"> ACTUALIZAR </button>
                </td>
              </tr>
              <tr>
                <td>Ducto</td>
                <td>Alarmas</td>
                <td>Sitios</td>
              </tr>
              <tr class="text-center" v-for="(row, key, index) in tablaConteo" :key="key">
                <td v-for="(r, k, i) in row" :key="k" style="width: 33.33%"> {{ r }} </td>
              </tr>
              <tr class="organgeTR">
                <td>Total</td>
                <td>0</td>
                <td> {{sitiosTotal}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-6 col-xs-12">
        <div class="panel-body">
          <table class="table">
            <thead>
              <tr class="text-center nombre-alarma">
                <th colspan="4">Estaciones Fuera de Línea</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" height="30px" >
                <td> Ducto </td>
                <td> Estación </td>
                <td> Última Recepción </td>
                <td> Horas Activo </td>
              </tr>
              <tr class="text-center" v-for="(row, key, index) in tablaFuera" :id="'alarm-' + key" :key="key">
                <td v-for="(r, k , i) in row" :key="k">{{ r }}</td>
              </tr>
              <tr class="organgeTR">
                <td colspan="3"></td>
                <td>0</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-md-12 col-xs-12">
       <div class="panel-body" style="height: 50vh;">
          <table class="table">
            <thead>
              <tr class="text-center nombre-alarma">
                <th colspan="5">Información General Ductos</th>
              </tr>
            </thead>
            <tbody>
              <tr class="text-center" height="30px" >
                <td> Ducto </td>
                <td> No. Est </td>
                <td> Km. Inicial </td>
                <td> Km. Final </td>
                <td> Km. Total </td>
              </tr>
              <tr class="text-center" v-for="(row, key, index) in tablaInfo" :id="'alarm-' + key" :key="key">
                <td v-for="(r, k, i) in row" :key="k" style="width: 20%;"> {{ r }} </td>
              </tr>
              <tr class="organgeTR">
                <td></td>
                <td>111</td>
                <td></td>
                <td>000</td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <button id="loading-btn" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
    <modal :name="info.modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>


<script>
let Modal = () => import('reusable/Modal')
let LoadingModal = () => import('components/Modals/LoginModal')
import SelectC from 'reusable/Select'
import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import toastr from 'toastr'

export default {
  data() {
    return {
      info: {
        modalName: 'loading-modal'
      },
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsFecha,
      tablaConteo: [],
      tablaFuera: [],
      tablaInfo: [],
      sitiosTotal: 0,
      fecha: null
    }
  },
  components: {
    SelectC,
    DatePicker,
    LoadingModal,
    Modal,
  },
  methods: {
    loading() {
      document.querySelector('#loading-btn').click()
    },
    actualizar() {
      this.loading()
      this.$store.dispatch('LOAD_GENERAL', {fecha: this.fecha})
      .then(resp => {
        if(resp.data.length === 0) {
            toastr.error('No se encontró información')
            this.loading()
            return
          }
        this.tablaConteo = []
        resp.data.forEach(re => {
          let temp = JSON.parse(re.section_info)
          this.sitiosTotal += Number(temp.site_count)
          this.tablaConteo.push({
            ducto: temp.section_name,
            alarms: temp.alarm_count,
            sitios: temp.site_count
          })
        })
        this.loading()
      })
    }
  },
  mounted() {
    setTimeout(() => {
      this.loading()
    }, 500)
    this.$store.dispatch('LOAD_GENERAL', {fecha: null})
      .then(resp => {
        resp.data.forEach(re => {
          let temp = JSON.parse(re.section_info)
          this.tablaInfo.push({
            ducto: temp.section_name,
            site: temp.site_count,
            kmInit: temp.km_init,
            kmFinal: temp.km_final,
            kmTracked: temp.km_tracked
          })
          this.sitiosTotal += Number(temp.site_count)
          this.tablaConteo.push({
            ducto: temp.section_name,
            alarms: temp.alarm_count,
            sitios: temp.site_count
          })


          let s = temp.sites
          s.forEach(r => {
            if(!r.last_info || (r.time_since_last_info < 0 || r.time_since_last_info > 300)){
              this.tablaFuera.push({
                ducto: temp.section_name,
                est: r.site_name,
                info: r.last_info || 'No Info',
                hours: (r.time_since_last_info === -1) ? 'No Info' : r.time_since_last_info
              })
            }
          })
        })
        setTimeout(() => {
          this.loading()
        }, 500)
      })
    },
  }
</script>

<style lang="scss" scoped>
@import '~varmix';

.col-md-6,
.col-xs-12 {
  padding: 0px !important;
}

.container-fluid {
  background-color: white;
  width: 100%;
  padding: 0;
  margin: 0;
}

table,
.panel-body {
  overflow: scroll;
  height: 70vh; // width: 50vw;
  padding: 0px 0;
  margin: 0;
  .organgeTR {
    background-color: $amarilloC;
    color: white;
  }
  .info {
    td {
      background-color: $bg;
    }
  }
  th {
    text-align: center;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: center;
    padding-left: 25px;
  }
  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

.btn-default {
  background: $amarilloO;
  &:hover,
  &:focus,
  &:active {
    background: $amarilloC !important;
  }
}

#reportes-page {
  padding-top: 50px;
  height: 100vh;
  background-color: $bg;
  #formulario-top {
    height: 15vh;
    @include celphone {
      height: 45vh;
    }
  }

  #range-wrapper {
    margin: 50px auto;
  }
}

// range
.color-2 .irs-bar,
.color-2 .irs-bar-edge {
  background: red;
}

.panel {
  margin-bottom: 0;
}

.fa {
  margin-left: 3px;
  margin-top: 3px;
  @include cMax(1010px) {
    margin-top: -5px;
    margin-left: 13px;
  }
  @include tablet {
    margin-left: 3px;
    margin-top: 3px;
  }
  @include cMax(582px) {
    margin-top: -5px;
    margin-left: 13px;
  }
  @include cMax(415px) {
    margin-left: 12px;
    margin-top: 3px;
  }
}

.row {
  margin-right: 0px;
}

.no-show {
  display: none;
}

h3 {
  color: black;
  cursor: pointer;
}

span {
  padding: 0 20px;
  @include cMax(400px) {
    padding: 0 10px;
  }
}

table,
.panel-body {
  background-color: $bg;
  overflow: scroll;
  height: 40vh;
  padding: 0;
  padding-left: 0px;
  border-top: 1px solid #999;
}

table {
  height: 35vh;
}

.not-active {
  color: $inactive;
}

.col-md-5,
.col-md-7 {
  margin: 0;
  padding: 0;
}

.panel-default {
  background-color: $gray;
  border: none;
  border-radius: 0;
}

#data-table {
  position: absolute;
  color: $titles;
  width: 100vw;
  height: 30vh;
  bottom: 0;
}

#ductos {
  h3 {
    padding-left: 15px;
  }
  .ducto {
    color: white;
    font-size: 12px;
    cursor: pointer;
    background-color: $amarilloC;
  }
}

#alarmas {
  th {
    text-align: left;
    padding-left: 25px;
    @include cMax(415px) {
      font-size: 12px;
    }
  }
  td {
    text-align: left;
    padding-left: 25px;
    background-color: $bg;
    i {
      color: $inactive;
      cursor: pointer;
      &:hover {
        color: $amarilloC;
      }
    }
  }
  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

#comentario-modal {
  h3 {
    color: $titles;
  }

  .btn-default {
    background-color: $amarilloC;
    &:hover,
    &:active,
    &:focus {
      background-color: $amarilloO !important;
    }
  }

  label {
    color: $amarilloC;
  }
  #label-name {
    color: white;
    width: 100%;
    font-size: 16px;
    padding: 5px;
    background-color: $amarilloC;
  }

  #selectDonde {
    -webkit-appearance: none;
    -webkit-border-radius: 0px;
    width: 80%;
    height: 40px;
    padding: 5px;
  }
}
#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// General.vue?1c92748c